import { useMembershipStore } from "../stores/membership-store";

export const useMembership = () => {
	const memberships = useMembershipStore((state) => state.memberships);
	const invites = useMembershipStore((state) => state.invites);
	const indexMembership = useMembershipStore((state) => state.indexMembership);
	const createMembership = useMembershipStore((state) => state.createMembership);
	const updateMembershipRole = useMembershipStore((state) => state.updateMembershipRole);
	const deleteMembership = useMembershipStore((state) => state.deleteMembership);
	const resendMembershipInvitation = useMembershipStore((state) => state.resendMembershipInvitation);

	return {
		memberships,
		invites,
		indexMembership,
		createMembership,
		updateMembershipRole,
		deleteMembership,
		resendMembershipInvitation,
	};
};

// Export both names for backward compatibility
export const useMemberships = useMembership;
